import { AxiosInstance } from 'axios';
import { ShiftPatternsOrderRepository } from '@/model/repository/shift/ShiftPatternsOrderRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): ShiftPatternsOrderRepository => ({
    update(payload) {
      return Repository.put(resource, payload);
    },
  });
